export default Object.freeze({
  Reports: 3,
  RequestUbicationAT: 90,
  RegistryHistory: 20,
  User: 179,
  DigitalSignature: 289,
});
